function asString(companyInfo) {
  const { name, address, postalCode, city } = companyInfo;
  return `${name}, ${address}, ${postalCode} ${city}`;
}

export default asString;
